// Increase this when orders may contain more distinct items.
export const MAX_ORDER_ITEMS = 1;
